import { CircleRounded } from '@mui/icons-material';
import { Stack, Tooltip, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface RenderCompareFieldValueHeaderOptions {
  compareLabel: string;
  compareLabelPrefix: string;
  color: string;
  totalFeedbackCount?: number;
  tooltipTitle?: ReactNode;
  shouldBreakInTwoLines?: boolean;
}

export const renderCompareFieldValueHeader = ({
  compareLabelPrefix,
  color,
  totalFeedbackCount,
  compareLabel,
  tooltipTitle,
  shouldBreakInTwoLines,
}: RenderCompareFieldValueHeaderOptions) => {
  return (
    <Tooltip
      arrow
      title={tooltipTitle || ''}
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: '350px',
            minWidth: '150px',
          },
        },
      }}
    >
      <Stack
        direction="column"
        alignItems="center"
        sx={{ textAlign: 'right', lineHeight: '12px' }}
      >
        <Stack
          direction={shouldBreakInTwoLines ? 'column' : 'row'}
          alignItems="center"
          justifyContent="flex-end"
          spacing={shouldBreakInTwoLines ? 0 : 0.5}
        >
          <Typography variant="subtitle2" lineHeight="inherit">
            {compareLabelPrefix}
          </Typography>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <CircleRounded sx={{ width: 10 }} style={{ color }} />
            <Typography variant="subtitle2" lineHeight="inherit">
              {compareLabel}
            </Typography>
          </Stack>
        </Stack>
        {totalFeedbackCount !== undefined && (
          <Typography variant="caption" color="text.secondary">
            (Total Records: {totalFeedbackCount})
          </Typography>
        )}
      </Stack>
    </Tooltip>
  );
};
